import { KBarPortal } from "kbar";
import {
    KeyboardShortcuts,
    SearchContainer,
    SearchFooter,
    ShortcutKey,
    StyledKBarAnimator,
    StyledKBarPositioner,
    StyledKBarSearch,
} from "./styled";
import { RenderResults } from "./RenderResults";
import { setLastGlobalSearchQuery } from "Header/store/headerSlice";
import { useDispatch } from "react-redux";
import { useLastGlobalSearchQuery } from "Header/store/selector";

const KBarContent = () => {
    const dispatch = useDispatch();
    const lastGlobalSearchQuery = useLastGlobalSearchQuery();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setLastGlobalSearchQuery(e.target.value));
    };

    const initializeKBar = () => {
        if (lastGlobalSearchQuery) {
            dispatch(setLastGlobalSearchQuery(""));
        }
    };

    return (
        <KBarPortal>
            <StyledKBarPositioner>
                <StyledKBarAnimator>
                    <SearchContainer>
                        <StyledKBarSearch
                            onChange={handleChange}
                            onFocus={initializeKBar}
                            placeholder="Search for pages, actions, or content..."
                        />
                    </SearchContainer>
                    <RenderResults />
                    <SearchFooter>
                        <KeyboardShortcuts>
                            <span>
                                <ShortcutKey>↑</ShortcutKey>
                                <ShortcutKey>↓</ShortcutKey> to navigate
                            </span>
                            <span>
                                <ShortcutKey>↵</ShortcutKey> to select
                            </span>
                            <span>
                                <ShortcutKey>esc</ShortcutKey> to close
                            </span>
                        </KeyboardShortcuts>
                    </SearchFooter>
                </StyledKBarAnimator>
            </StyledKBarPositioner>
        </KBarPortal>
    );
};

export default KBarContent;
